import ViewDeveloperUserPage from "../../../component/users/developers/ViewDeveloperUser"

  
 
function ViewDeveloperUser() {
  return (
    <div className='page-body'>

       < ViewDeveloperUserPage/>
        </div>
  )
}

export default ViewDeveloperUser